module.exports = __webpack_public_path__ + "img/scene4-3.05946c13.png";